import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import * as batshit from '@yornaath/batshit';


export type CollaborativeChartsReviewConfigFrequency = 'weekly' | 'monthly' | 'quarterly' | 'annually';

export type CollaborativeChartsReviewConfig = {
  stateId: string;
  frequency: CollaborativeChartsReviewConfigFrequency;
  sampleChartsAmountPercentage: number;
  minimumChartsAmount: number;
  maximumChartsAmount: number;
};


export const getCollaborativeChartsReviewConfigsByIds = async (stateIds?: string[]) => restClient.request<{ data: CollaborativeChartsReviewConfig[] }>('/api/v1/collaborative_charts_review_config', {
  method: 'POST',
  data: {
    ids: stateIds,
  }
});


const collaborativeChartsReviewConfigBatch = batshit.create({
  fetcher: async (stateIds: string[]) => {
    const response = await getCollaborativeChartsReviewConfigsByIds(stateIds.filter(Boolean));

    return response.data;
  },
  resolver: (response, key) => response?.find((item) => item.stateId === key) ?? null,
  scheduler: batshit.windowScheduler(10)
});

export const getCollaborativeChartsReviewConfigById = async (stateId: string) => collaborativeChartsReviewConfigBatch.fetch(stateId);


export type UpdateCollaborativeChartsReviewConfigParams = CollaborativeChartsReviewConfig;
export const updateCollaborativeChartsReviewConfig = async (params: UpdateCollaborativeChartsReviewConfigParams) => restClient.request<null>(`/api/v1/collaborative_charts_review_config/${params.stateId}`, {
  method: 'PUT',
  data: snakecaseKeys(params)
});

export const deleteCollaborativeChartsReviewConfig = async (stateId: string) => restClient.request<null>(`/api/v1/collaborative_charts_review_config/${stateId}`, {
  method: 'DELETE',
});
